export const OTP_LENGTH = 5
export const RESEND_TIME = 120
